import { useState, useEffect } from 'react';
import { CONFIG_CDN_URL } from '../constants';

export const useConfig = (clientId) => {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const url = `${CONFIG_CDN_URL}/${clientId}/Liveness/configV6.json`;
                const res = await fetch(url);
                if (res.ok) {
                    const data = await res.json();
                    setConfig(data);
                }
            } catch (e) {
                console.error('Error fetching config:', e);
            } finally {
                setLoading(false);
            }
        };
        fetchConfig();
    }, [clientId]);

    return { config, loading };
};
